import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  timeout: 30000,
  transformRequest: [...axios.defaults.transformRequest],
  transformResponse: [...axios.defaults.transformResponse],
  headers: { ...axios.defaults.headers },
});

// Always read the latest token from localStorage on every request
api.interceptors.request.use(
  function (config) {
    const loggedIn = localStorage.getItem("loggedIn");
    const token = loggedIn ? JSON.parse(loggedIn)?.token : null;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);


api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      window.location.href = "/auth/login";
      localStorage.removeItem("loggedIn");
    }
    return Promise.reject(error);
  },
);

export default api;
